import api from "@/configs/axios-config";

export type flagPartParam = {
  search_filter?: string;
  is_flagged?: boolean;
  buyer_id?: string;
  approval_id?: string;
  is_admin_flagged?: boolean;
  part_id?: number;
  skip?: number;
  limit?: number;
};

export type flagPartData = {
  part_id: number;
  part_number: string;
  part_name: string;
  first_tier_supplier: string;
  first_tier_supplier_code: string;
  buyer_id: string;
  material_supplier: string;
  material_code: string;
  is_flagged: boolean;
  flagged_reason: string;
  approval_id: string;
  is_admin_flagged: boolean;
};

export const getFlaggedParts = async (
  params: flagPartParam,
): Promise<{ total: number; data: flagPartData[] }> => {
  const response = await api.get(`/flagged-parts/`, { params });
  return response.data;
};

export const flagPart = async (
  partId: number,
  reason: Set<string>,
  isFlagged: boolean,
) => {
  await api.post(`/flagged-parts/flag/${partId}`, {
    is_flagged: isFlagged,
    flagged_reason: Array.from(reason),
  });
};

export type unFlagPartParam = {
  partIds: number[];
  reason_id: number;
  is_admin_flagged: boolean;
};

export const unFlagParts = async (params: unFlagPartParam) => {
  await api.post(`/flagged-parts/unflag`, {
    part_ids: params.partIds,
    reason_id: params.reason_id,
    is_admin_flagged: params.is_admin_flagged,
  });
};

export type unflagAllParam = {
  filter: flagPartParam;
  reason_id: number;
  is_admin_flagged: boolean;
};

export type unflagAllResult = {
  affected_count: number;
  success: boolean;
};

export const unflagAllMatchingFilter = async (
  params: unflagAllParam,
): Promise<unflagAllResult> => {
  const response = await api.post(`/flagged-parts/unflag-all`, params);
  return response.data;
};

export const changeToAdminFlagged = async (partIds: number[]) => {
  await api.post(`/flagged-parts/admin-flag`, {
    part_ids: partIds,
  });
};

export type versionCheckPart = {
  part_id: number;
  version: string;
};

export const checkVersionPart = async (partId: number): Promise<versionCheckPart> => {
  const response = await api.get(`/first-tier-suppliers/part-price/check/${partId}`);
  return response.data;
}